import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeadCell } from "./userAppShared";

const UserAppTicketsTab = ({ tickets }: { tickets?: any[] }) => {
  const { t } = useTranslation();
  const na = t("user_app.na");
  const formatDate = (value?: string) => (value ? new Date(value).toLocaleDateString() : na);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <HeadCell>{t("user_app.tickets.id")}</HeadCell>
            <HeadCell>{t("user_app.tickets.title")}</HeadCell>
            <HeadCell>{t("user_app.tickets.description")}</HeadCell>
            <HeadCell>{t("user_app.tickets.status")}</HeadCell>
            <HeadCell>{t("user_app.tickets.created_date")}</HeadCell>
            <HeadCell>{t("user_app.tickets.last_modified")}</HeadCell>
            <HeadCell>{t("user_app.tickets.messages")}</HeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tickets?.map((ticket: any, index: number) => (
            <TableRow key={index}>
              <TableCell>
                {ticket.id || t("user_app.tickets.ticket_fallback", { n: index + 1 })}
              </TableCell>
              <TableCell>{ticket.title || na}</TableCell>
              <TableCell>{ticket.description || na}</TableCell>
              <TableCell>
                <Chip
                  label={ticket.status || na}
                  size="small"
                  color={ticket.status === "WAITING" ? "warning" : "default"}
                />
              </TableCell>
              <TableCell>{formatDate(ticket.created_date)}</TableCell>
              <TableCell>{formatDate(ticket.last_modified_date)}</TableCell>
              <TableCell>
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {t("user_app.tickets.messages_count", { n: ticket.list_message?.length || 0 })}
                  </Typography>
                  {ticket.list_message?.[0]?.message && (
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                      {t("user_app.tickets.latest", { message: ticket.list_message[0].message })}
                    </Typography>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserAppTicketsTab;
